define('app/views/success_bank_card_submit_btn_view',['app/setup', 'app/views/base_view'], function (takhfifan, baseView) {

  takhfifan.SuccessBankCardSubmitBtnView = takhfifan.BaseView.extend({

    initialize: function () {
      var self = this;
      this.$el.click(function(e) {
        self.addLoading();
        takhfifan.eventHub.trigger('successBankCardBtn:clicked',{});
      });

      takhfifan.eventHub.on('successBankCard:addCardApiCalled', function () {
        self.removeLoading();
      }, this);
    },

    addLoading: function (){
      this.$el.addClass('loading');
      this.$el.prop("disabled",true);
      this.$el.empty().append('<span class="spinner"></span>');
    },

    removeLoading: function (){
      this.$el.removeClass('loading');
      this.$el.prop("disabled",false);
      this.$el.empty().append('ثبت');
    },
  })
});
